import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  designColors,
  designRadii,
  designWeights,
} from "services/constants/designTokens";

// The strip only opens the drawer; it never navigates away from Home.
export const ActionRequiredStrip = ({ count, onClick }) => {
  if (!count) return null;

  return (
    <Alert
      severity="warning"
      icon={false}
      onClick={onClick}
      sx={{
        mb: 2.5,
        borderRadius: designRadii.banner,
        border: "1px solid #FED7AA",
        backgroundColor: "#FFFBEB",
        color: designColors.slate800,
        cursor: "pointer",
        "& .MuiAlert-message": { width: "100%" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          gap: 1.5,
        }}
      >
        <Typography fontWeight={designWeights.semibold} sx={{ fontSize: 14 }}>
          Action required: {count} item{count === 1 ? "" : "s"} need your
          attention
        </Typography>
        <ChevronRightIcon sx={{ color: designColors.slate600 }} />
      </Box>
    </Alert>
  );
};
